<template>
  <el-dialog
    :visible.sync="settledVisible"
    width="400px"
    :modal-append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :append-to-body="true"
    custom-class="settleddialog"
    top="238px"
    @open="open"
    @close="close"
  >
    <template slot="title">
      <div class="settledtitle"><i class="iconfont icon-info-circle-filled"></i>您尚未获得生态专区订单报价权限</div>
    </template>
    <div class="explain">
      <div class="explainItem">
        1.工厂承诺函 <i class="iconfont" :class="isSettledInfo?.undertakingLetter?'icon-check':'icon-close'"></i>
      </div>
      <div class="explainItem" v-if="!isSettledInfo?.myBankChannel">
       2.开通监管账号 <i class="iconfont" :class="isSettledInfo?.escrowAccount?'icon-check':'icon-close'"></i>
      </div>
      <div class="explainItem" v-if="isSettledInfo?.myBankChannel">
       2.网商银行资金分账授权 <i class="iconfont" :class="isSettledInfo?.myBankAuth?'icon-check':'icon-close'"></i>
      </div>
      <div class="explainItem" v-for="(item,index) in showAgreementList" :key="index">
        {{3+index}}.{{item.name}} <i class="iconfont " :class="isSettledInfo.signedAgreementTypeList.includes(item.type) ? 'icon-check':'icon-close'"></i>
      </div>
      <!-- <div class="explainItem" v-if="channel==30">
        3.平台服务协议 <i class="iconfont " :class="isSettledInfo?.platformServiceAgreement?'icon-check':'icon-close'"></i>
      </div>
      <div class="explainItem" v-if=" channel==20">
        4.甄云授权书 <i class="iconfont" :class="isSettledInfo?.authorizationLetter?'icon-check':'icon-close'" ></i>
      </div> -->
      <div class="btnDiv">
        <div>
          <el-button class="signProtocolBtn" @click="goAgreement" v-if="!isgoAgreement">去资料库签署协议</el-button>
        </div>
        <div>
          <el-button class="regulatoryAccountBtn" @click="goBank" v-if="!isSettledInfo?.escrowAccount">去开通银行监管账号</el-button>
        </div>
        <div>
          <el-button class="regulatoryAccountBtn" @click="goAuth" v-if="isSettledInfo.escrowAccount && isSettledInfo.myBankChannel && !isSettledInfo?.myBankAuth">去完成网商分账授权</el-button>
        </div>
      </div>
      <div class="help">
        如需帮助，请联系{{ salesInfoClient?.name }} {{ salesInfoClient?.phone }}
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { onlineUrl,presentUrl } from '@/utils/config';
import zhenyunOrderMinxis from "@/mixins/zhenyunOrder.js";
export default {
  mixins: [zhenyunOrderMinxis],
  props:{
    salesInfoClient:{
      default:null
    },
    channel:{
      type:Number,
      default:20
    },
    showAgreementList:{
      type:Array,
      default:()=>[]
    },
    currentChannle:{
      type:Number,
      default:20
    }
  },
  data() {
    return {
      settledVisible: false,
      presentUrl:presentUrl,
      onlineUrl:onlineUrl,
      isSettledInfo:{
        signedAgreementTypeList:[]
      },

    };
  },
  computed:{
     isgoAgreement(){
      if(!this.showAgreementList?.length){
        return false
      }
      const agreementList = this.showAgreementList.map(k => k.type)
      return agreementList.every(item => 
        this.isSettledInfo.signedAgreementTypeList.includes(item)
      )
    }
  },
  methods: {
    goAuth(){
      if(!this.isgoAgreement){
        return this.$message.warning('请先去资料库完成协议签署')
      }
      window.open(`${onlineUrl}/purchase-order/supplier/financial/collection-set`,'_target')
    },
   // 跳转协议管理
    goAgreement(){
      let url = this.presentUrl+'/partner/agreement-repository'
      window.open(url,'_target')
    },
    // 开通银行账号
    goBank(){
      let url = this.onlineUrl+'/purchase-order/supplier/financial/collection-set'
      window.open(url,'_target')
    },
    open(){
      this.getOnboarding(this.channel)
    },
    async close(){
      await this.getOnboarding(this.channel)
      if(this.isgoAgreement){
        this.$emit('changeDetails','agree',true)
      }
    }

  },
};
</script>
<style lang="scss" scoped>
:deep(.settleddialog) {
  border-radius: 8px;
  font-family: SourceHanSansCN-Regular ;
  .settledtitle {
    color: #222222;
    font-size: 18px;
    font-weight: 700;
    line-height: 28px;
    i{
      font-size: 20px;
      color: #FF7800;
      font-weight: 400;
      margin-right: 8px;
    }
  }
  .el-dialog__header {
    padding: 24px;
  }
  .el-dialog__close {
    color: #999999;
    font-size: 20px;
    line-height: 28px;
  }
  .el-dialog__headerbtn {
    top: 25px;
  }
  .el-dialog__body{
    color: #555555;
    padding: 0px 24px 24px 24px ;
  }


  .el-dialog__footer{
    padding-top: 0px;
  }
  .btnDiv{
    margin-top: 32px;
  }
  .signProtocolBtn{
    width: 100%;
    margin-bottom: 8px;
    border: 1px solid #0863FF;
    color: #0863ff;
    background: #FFF;
    font-size: 14px;
  }
  .signProtocolBtn:hover{
    border: 1px solid #0863FF;
    color: #0863ff;
    background: #FFF;
  }
  .regulatoryAccountBtn{
    width: 100%;
    border: 1px solid #0863FF;
    color: #0863ff;
    font-size: 14px;
    margin-bottom: 8px;
  }
  .regulatoryAccountBtn:hover{
    border: 1px solid #0863FF;
    color: #0863ff;
    background: #FFF;
  }
  .help{
    margin-top: 8px;
    color: #98a3b7;
    font-size: 12px;
    font-weight: 400;
    text-align: center;
  }
  .explainItem{
    color: #555555;
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    display: flex;
    margin-top: 8px;
    i{
      margin-left: auto;
      font-size: 16px;
    }
    .icon-close{
      color: #FF081F;
    }
    .icon-check{
      color: #20B820;
    }
  }
}


</style>